import React from 'react';
import { ListItem } from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { getIconLabel } from './icon-definitions';

const pt = PropTypes;

const SalientIconItem = (props) => {
  const { iconData, iconSetIndex } = props;
  const { icon: IconComponent, labels, alt } = iconData;
  const label = getIconLabel(labels, iconSetIndex);

  // eslint-disable-next-line max-len
  const containerClasses = 'sui-list-none !sui-p-0 sui-text-base sui-leading-normal sui-font-regular sui-flex sui-flex-row sui-items-center sui-w-full sm:sui-w-40 lg:sui-w-full';

  return (
    <ListItem className={containerClasses}>
      <div className="sui-w-8 sui-h-8 sui-flex-shrink-0 sui-flex sui-items-center sui-justify-center">
        <IconComponent
          className="sui-w-full sui-h-full"
          style={{
            width: '32px',
            height: '32px',
            maxWidth: '32px',
            maxHeight: '32px',
            display: 'block'
          }}
          aria-label={alt}
        />
      </div>
      <span className="sui-ml-2 sui-text-wrap sui-line-clamp-2">{label}</span>
    </ListItem>
  );
};

SalientIconItem.displayName = 'SalientIconItem';

SalientIconItem.propTypes = {
  iconData: pt.shape({
    icon: pt.func.isRequired,
    labels: pt.arrayOf(pt.string).isRequired,
    alt: pt.string.isRequired
  }).isRequired,
  iconSetIndex: pt.number.isRequired
};

export { SalientIconItem };
